import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import {
  AreaInput,
  checkNumeric,
  formatNumber,
  randInt,
  renderFractionUserAnswer,
} from "./PyramidVolumeCommon";

export function generateTask() {
  const h = randInt(4, 18);
  const baseArea = 3 * randInt(8, 32);
  const volume = (baseArea * h) / 3;
  return {
    type: "PyramidBaseAreaFromVolumeTask",
    data: { baseArea, h, volume },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>Dany jest ostrosłup o objętości i wysokości:</p>
      <BlockMath
        math={`V=${formatNumber(data.volume)}\\,\\text{cm}^3,\\quad H=${data.h}\\,\\text{cm}`}
      />
      <p>Oblicz pole podstawy tego ostrosłupa.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <AreaInput value={userAnswer} onChange={onChange} disabled={disabled} label="P_p" />
  );
}

export function checkAnswer({ data }, userAnswer) {
  return checkNumeric(userAnswer, data.baseArea);
}

export function renderAnswer({ data }) {
  return <InlineMath math={`P_p=${data.baseArea}\\,\\text{cm}^2`} />;
}

export function renderUserAnswer(userAnswer) {
  return renderFractionUserAnswer(userAnswer, "P_p", String.raw`\text{cm}^2`);
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> Korzystamy ze wzoru na objętość ostrosłupa.
      </p>
      <BlockMath math={"V=\\frac{1}{3}P_p\\cdot H"} />
      <p>
        <strong>Krok 2:</strong> Przekształcamy wzór tak, aby obliczyć pole podstawy.
      </p>
      <BlockMath math={"P_p=\\frac{3V}{H}"} />
      <BlockMath
        math={`P_p=\\frac{3\\cdot ${formatNumber(data.volume)}}{${data.h}}=${data.baseArea}\\,\\text{cm}^2`}
      />
    </div>
  );
}
